<div class="category-grid">
  @for (category of categoryPotentials; track category.category) {
    <article class="category-card" [class.leading]="isLeadingCategory(category.potential)">
      <h3>{{ categoryLabelKey(category.category) | translate }}</h3>
      <strong>{{ category.potential | number: '1.1-1' }} kg</strong>
      <div class="potential-track" aria-hidden="true">
        <span [style.width.%]="categoryBarWidth(category.potential)"></span>
      </div>
      @if (isLeadingCategory(category.potential)) {
        <p class="leading-label">
          <mat-icon aria-hidden="true">north_east</mat-icon>
          {{ 'dairyYieldScan.summary.categories.mostPotential' | translate }}
        </p>
      }
    </article>
  }
</div>
